var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, ContentFrame, LayoutContent, LayoutControls, } from '@pinwheel/origami';
import { useSelector } from 'react-redux';
import React, { useEffect, useMemo, useState } from 'react';
import { getSubmitPayload, isFieldInvalid, isValueTruthy } from './utils';
import Actions from '../Action/TemplateFormActions';
import InputField from './_InputField';
import { selectFailedLoginAttempts, selectDocumentUploads, } from '../../../state/slices/slice-document-uploads';
import { useGetLocalizedString } from '../../../hooks/useGetLocalizedString';
import useLinkNavigate from '../../../hooks/useLinkNavigate';
import { selectFeatureFlags } from '../../../state/slices/slice-link-params';
import { useAppSelector } from '../../../state';
import { DocumentUploadsExperience } from '../../../types/document-uploads';
function TemplateForm(_a) {
    var fieldConfigs = _a.fieldConfigs, _b = _a.initialValues, initialValues = _b === void 0 ? {} : _b, onSubmit = _a.onSubmit, submitButtonText = _a.submitButtonText, _c = _a.submitButtonEventId, submitButtonEventId = _c === void 0 ? 'TemplateForm-continue' : _c, actions = _a.actions, children = _a.children, extraControlsTop = _a.extraControlsTop, extraControlsBottom = _a.extraControlsBottom;
    var _d = useState(initialValues), fieldValues = _d[0], setFieldValues = _d[1];
    var failedLoginAttempts = useSelector(selectFailedLoginAttempts);
    var getLocalizedString = useGetLocalizedString();
    var navigate = useLinkNavigate();
    var featureFlags = useAppSelector(selectFeatureFlags);
    var documentUploads = useSelector(selectDocumentUploads);
    // JANK - due to re-renders, initialValues can get reset - this ensures it is respected if it changes
    useEffect(function () {
        if (initialValues && Object.keys(initialValues).length >= 1) {
            setFieldValues(initialValues);
        }
    }, [initialValues]);
    var errors = useMemo(function () {
        return fieldConfigs.reduce(function (acc, fieldConfig) {
            var _a;
            var errorMsg = isFieldInvalid(fieldConfig, fieldValues[fieldConfig.key]);
            if (errorMsg)
                return __assign(__assign({}, acc), (_a = {}, _a[fieldConfig.key] = errorMsg, _a));
            return acc;
        }, {});
    }, [fieldConfigs, fieldValues]);
    var submittable = useMemo(function () {
        return !Object.keys(errors).length &&
            fieldConfigs.every(function (c) {
                var val = fieldValues[c.key];
                return c.lockedField || isValueTruthy(val);
            });
    }, [fieldConfigs, fieldValues, errors]);
    var fieldElements = fieldConfigs.map(function (field, i) { return (React.createElement(InputField, { field: field, key: field.key, fieldValues: fieldValues, setFieldValues: setFieldValues, index: i, fieldCount: fieldConfigs.length })); });
    var onUploadDocumentsInsteadButtonClick = function () {
        navigate('/document-uploads/primer');
    };
    return (React.createElement(ContentFrame, { "data-testid": "TemplateForm", as: "form", onSubmit: function (e) { return e.preventDefault(); } },
        React.createElement(LayoutContent, null,
            children,
            fieldElements,
            React.createElement(Actions, { actions: actions, onSubmit: onSubmit })),
        React.createElement(LayoutControls, null,
            extraControlsTop,
            featureFlags.documentUploadsEnabled &&
                documentUploads === DocumentUploadsExperience.FALLBACK &&
                failedLoginAttempts >= 2 ? (React.createElement(Button, { variant: "outline", "data-testid": "DocumentUploads-upload-documents-instead-button", onClick: onUploadDocumentsInsteadButtonClick }, getLocalizedString('UPLOAD_DOCUMENT_INSTEAD'))) : null,
            React.createElement(Button, { eventId: submitButtonEventId, disabled: !submittable, "data-testid": "button", onClick: function () {
                    onSubmit(getSubmitPayload(fieldValues));
                    // setHasSubmitted(true);
                } }, submitButtonText || getLocalizedString('CONTINUE')),
            extraControlsBottom)));
}
export default TemplateForm;
